export enum AxiomaW1SignalStrength {
  EXCELLENT = 'EXCELLENT',
  GOOD = 'GOOD',
  FAIR = 'FAIR',
  POOR = 'POOR',
  NO_SIGNAL = 'NO_SIGNAL'
}
